/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ClosedReason {
  Other = 'Other',
  OutsideMonitoredHours = 'OutsideMonitoredHours',
  CapLimitReached = 'CapLimitReached'
}
